import { Component } from '@angular/core';

@Component({
	selector: 'sgp-skeleton-pesquisar-edital',
	templateUrl: './skeleton-pesquisar-edital.component.html'
})
export class SkeletonPesquisarEditalComponent {
	quantidade = Array(3);
}
